export default __webpack_public_path__ + "static/media/sol-dvss-MetadeDoTempo.e585a75c.jpeg";